export const MODULE_NAME = 'notifications';

export const KNOWN_NOTIFICATIONS_CAPACITY = 150;

export const ADDITIONAL_VISIBLE_NOTIFICATION_COUNT = 10;

export enum NotificationType {
    System = 'System',
    Message = 'Message',
}
